class CartRewardsBar extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('[data-threshold]'));
    this.messages = Array.from(this.querySelectorAll('[data-tier-message]'));

    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener('cart:updated', this.onCartUpdate);

    if (window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        this.onCartUpdate
      );
    }

    this.render(Number(this.dataset.subtotal) || 0);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdate);
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  /**
   * Le soglie sono espresse nella valuta del negozio, i totali del carrello in
   * quella di visualizzazione: il tasso allinea i due valori.
   */
  get thresholds() {
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    return this.steps.map((step) => Number(step.dataset.threshold) * rate);
  }

  onCartUpdate(event) {
    const cart = event?.detail?.cart || event?.cart;
    if (!cart) return;

    const subtotal = cart.items_subtotal_price ?? cart.total_price;
    if (typeof subtotal !== 'number') return;

    this.render(subtotal);
  }

  render(subtotal) {
    this.hidden = subtotal <= 0;

    const thresholds = this.thresholds;
    const activeIndex = thresholds.findIndex((threshold) => subtotal < threshold);

    this.style.setProperty('--percent', `${this.percentFor(subtotal, thresholds, activeIndex)}%`);
    this.steps.forEach((step, index) => {
      step.classList.toggle('is-unlocked', activeIndex === -1 || index < activeIndex);
    });
    this.classList.toggle('cart-rewards--complete', activeIndex === -1);

    const activeKey = activeIndex === -1 ? 'done' : String(activeIndex);
    let activeMessage = null;
    this.messages.forEach((message) => {
      const isActive = message.dataset.tierMessage === activeKey;
      message.hidden = !isActive;
      if (isActive) activeMessage = message;
    });

    const remaining = activeMessage?.querySelector('[data-remaining]');
    if (!remaining || activeIndex === -1) return;
    remaining.textContent = this.formatMoney(Math.max(thresholds[activeIndex] - subtotal, 0));
  }

  /**
   * Ogni premio occupa un segmento uguale della barra e il suo marcatore sta al
   * centro del segmento: l'avanzamento è lineare dentro il segmento in corso.
   */
  percentFor(subtotal, thresholds, activeIndex) {
    const count = thresholds.length;
    if (!count || activeIndex === -1) return 100;

    const previous = activeIndex === 0 ? 0 : thresholds[activeIndex - 1];
    const from = activeIndex === 0 ? 0 : ((activeIndex * 2 - 1) * 50) / count;
    const to = ((activeIndex * 2 + 1) * 50) / count;

    const span = thresholds[activeIndex] - previous;
    if (span <= 0) return from;

    return from + ((to - from) * Math.max(subtotal - previous, 0)) / span;
  }

  formatMoney(cents) {
    if (window.FoxTheme?.Currency?.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, window.FoxTheme.settings?.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }
}

if (!customElements.get('cart-rewards-bar')) {
  customElements.define('cart-rewards-bar', CartRewardsBar);
}
